import cx from "../../utils/cx.ts";

type Props = {
  isSelected: boolean;
  onChecked: () => void;
  onUnchecked: () => void;
};

export default function UncontrolledTabbedCheckbox({
  isSelected,
  onChecked,
  onUnchecked,
}: Props) {
  return (
    <div className="isolate flex divide-x divide-gray-200 rounded-lg shadow shadow-gray-400">
      <div
        className={cx(
          isSelected
            ? "text-gray-900 bg-sky-50"
            : "text-gray-500 bg-white hover:text-gray-700",
          "rounded-l-lg",
          "group relative min-w-0 flex-1 overflow-hidden py-2 px-4 text-center text-sm font-medium hover:bg-sky-50 focus:z-10 cursor-pointer",
        )}
        onClick={onChecked}
      >
        <span>Yes</span>
        <span
          aria-hidden="true"
          className={cx(
            isSelected ? "bg-sky-500" : "bg-transparent",
            "absolute inset-x-0 bottom-0 h-0.5",
          )}
        />
      </div>
      <div
        className={cx(
          !isSelected
            ? "text-gray-900 bg-sky-50"
            : "text-gray-500 bg-white hover:text-gray-700",
          "rounded-r-lg",
          "group relative min-w-0 flex-1 overflow-hidden py-2 px-4 text-center text-sm font-medium hover:bg-sky-50 focus:z-10 cursor-pointer",
        )}
        onClick={onUnchecked}
      >
        <span>No</span>
        <span
          aria-hidden="true"
          className={cx(
            !isSelected ? "bg-sky-500" : "bg-transparent",
            "absolute inset-x-0 bottom-0 h-0.5",
          )}
        />
      </div>
    </div>
  );
}
